import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onConsultationClick, onQuickAuditClick }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/95 to-secondary pt-24 pb-16 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="MessageCircle" size={20} className="text-white" />
            <span className="text-white/90 text-sm font-medium">Multiple Ways to Connect</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Let's Start Your
            <span className="block text-gradient-brand bg-gradient-to-r from-accent to-orange-400 bg-clip-text text-transparent">
              Digital Transformation
            </span>
          </h1>

          <p className="text-xl text-white/80 mb-8 max-w-3xl mx-auto leading-relaxed">
            Choose your preferred way to connect with our team. From quick audits to comprehensive consultations, 
            we're here to understand your vision and craft the perfect digital solution.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              variant="default"
              size="lg"
              className="bg-accent hover:bg-accent/90 text-white brand-hover-lift brand-shadow"
              iconName="Calendar"
              iconPosition="left"
              iconSize={20}
              onClick={onConsultationClick}
            >
              Book Free Consultation
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              className="border-white/30 text-white hover:bg-white/10 backdrop-blur-sm"
              iconName="Zap"
              iconPosition="left"
              iconSize={20}
              onClick={onQuickAuditClick}
            >
              Get Quick Audit
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center gap-6 mt-12 text-white/60">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} />
              <span className="text-sm">24hr Response</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} />
              <span className="text-sm">100% Confidential</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={16} />
              <span className="text-sm">Free Strategy Session</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;